module.exports = __webpack_public_path__ + "static/img/INTERPOLs.2692a82.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/partners/imgs/INTERPOLs.png
// module id = l5JH
// module chunks = 1